import React, { useEffect, useState } from "react";
import { formatInYardTimeZone } from "../../../utils/dateUtils";
import { YardDateField } from "../../../components/common/YardDateField";
import jsonExport from "jsonexport/dist";
import { fillDownRows } from "../../../utils/exportsUtils";

import { Card, Divider, Tab, Tabs, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  DateInput,
  downloadCSV,
  EditButton,
  FilterButton,
  FunctionField,
  ListContextProvider,
  ListToolbar,
  RefreshButton,
  ShowButton,
  SimpleList,
  TextField,
  Title,
  TopToolbar,
  useListContext,
} from "react-admin";

import { ChevronRightIcon } from "../../../components/common/iconography";
import ExportButton from "../../../components/common/ExportButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { SearchField } from "../../../components/common/SearchField";
import { Pagination } from "../../../components/Pagination";
import { useSearchableList } from "../../../dataProvider/useSearchableList";
import {
  InboundStatus,
  MAX_INVENTORY_QUERY_LIMIT,
} from "../../../utils/constants";
import {
  exceptionRenderer,
  exportCustomField,
  normalizeValue,
  truncateText,
} from "../../../utils/utils";
import { InboundStateIcon } from "../../../managerApp/resources/inboundShipments/InboundStateIcon";
import { useUser } from "../../../authenticatorApp/UserContext";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    transition: theme.transitions.create(["all"], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
}));

const tabs = [
  {
    id: InboundStatus.IN_TRANSIT,
    name: "PENDING",
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: InboundStatus.ARRIVED,
    name: "ARRIVED",
    sortKey: "notifyDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: InboundStatus.PLACED,
    name: "UNLOADING",
    sortKey: "placedDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: InboundStatus.RELEASED,
    name: "DEPARTED",
    sortKey: "releaseDateTime",
    sortOrder: "DESC",
    showSmall: false,
  },
];

const getVisibleTabs = (smDown) => {
  return tabs.filter((tab) => !smDown || tab.showSmall);
};

const exporter = (inbounds) => {
  const customHeaderMap = new Map();
  debugger;

  const inboundsForExport = inbounds.map((inbound) => {
    const inboundForExport = { ...inbound };

    if (inbound.inventories?.items) {
      inboundForExport.tallySheet = inbound.inventories.items.map(
        (inventory) => {
          const lineItem = {
            inventoryId: inventory.id,
            productCode: inventory.productCode,
            productName: inventory.productName,
            lotNumber: inbound.lotNumber,
            dateReceived: inbound.placedDateTime
              ? formatInYardTimeZone(
                  new Date(inbound.placedDateTime),
                  "MM/dd/yyyy",
                )
              : "",
            quantityReceived: inventory.quantityReceived,
            units: inbound.totalUOM,
            pieces: inbound.pcs,
          };

          return lineItem;
        },
      );
    }
    delete inboundForExport.inventories;

    if (inbound.customFields?.length > 0) {
      debugger;
      inbound.customFields.forEach((field) => {
        exportCustomField(field, inboundForExport, customHeaderMap);
      });
    }

    delete inboundForExport.account;
    delete inboundForExport.accountId;
    delete inboundForExport.area;
    delete inboundForExport.areaId;
    delete inboundForExport.assignedTo;
    delete inboundForExport.carrierType;
    delete inboundForExport.createdAt;
    delete inboundForExport.createDateTime;
    delete inboundForExport.daysOnDemurrageClock;
    delete inboundForExport.endDateTime;
    delete inboundForExport.groups;
    delete inboundForExport.history;
    delete inboundForExport.invoiceId;
    delete inboundForExport.notes;
    delete inboundForExport.owner;
    delete inboundForExport.attachments;
    delete inboundForExport.photos;
    delete inboundForExport.reloadYardCommodity;
    delete inboundForExport.reloadYardCommodityId;
    delete inboundForExport.reloadYardId;
    delete inboundForExport.seals;
    delete inboundForExport.startDateTime;
    delete inboundForExport.state;
    delete inboundForExport.stripeBillingDateTime;
    delete inboundForExport.updatedAt;
    delete inboundForExport.verificationRequired;
    delete inboundForExport.zone;
    delete inboundForExport.zoneId;

    return inboundForExport;
  });

  jsonExport(
    fillDownRows(inboundsForExport),
    { rename: ["inboundShipmentId"] },
    (err, csv) => {
      downloadCSV(csv, `inboundShipments_${new Date().toLocaleDateString()}`); // download as 'inboundShipments.csv` file
    },
  );
};

const InboundSearchField = (props) => {
  const { label, alwaysOn } = props;
  const { displayedFilters, filterValues, setFilters } = useListContext(props);

  const handleSearch = (value) => {
    debugger;
    if (value) {
      const normalizedValue = normalizeValue(value);
      delete filterValues.or;
      setFilters(
        {
          ...filterValues,
          or: [
            { shipFrom: { matchPhrasePrefix: `${value}` } },
            { shipFrom: { matchPhrasePrefix: `${value}` } },
            // { normalizedPoNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            // { normalizedRailCarNumber: { matchPhrasePrefix: `${value}` } },
            { normalizedPoNumber: { wildcard: `*${normalizedValue}*` } },
            { normalizedRailCarNumber: { wildcard: `*${normalizedValue}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      delete filterValues.or;
      setFilters(filterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (visibleTabs, tabIndex) => {
  const filters = [<InboundSearchField label="Search" alwaysOn />];

  if (visibleTabs[tabIndex].id === InboundStatus.RELEASED) {
    filters.push(
      <DateInput
        source="releaseDateTime.lte"
        label="Released Before..."
        variant="outlined"
        resettable
        onKeyPress={(event) => event.preventDefault()}
      />,
      <DateInput
        source="releaseDateTime.gte"
        label="Released After..."
        variant="outlined"
        resettable
        onKeyPress={(event) => event.preventDefault()}
      />,
    );
  }
  return filters;
};

const ListActions = (props) => {
  const { xsDown } = props;
  const { resource, total } = useListContext();

  return !xsDown ? (
    <TopToolbar>
      <FilterButton />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        exporter={exporter}
        perPage={MAX_INVENTORY_QUERY_LIMIT}
      />
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

// The PENDING tab (status IN_TRANSIT) is the carrier's dispatch queue: rows
// open the edit form so the delivery can be scheduled. Every other tab is a
// record of what already happened — read-only.
const getRowClickAction = (tabValue) =>
  tabValue === InboundStatus.IN_TRANSIT ? "edit" : "show";

const getSortOrder = (visibleTabs, tabIndex) => {
  return visibleTabs[tabIndex].sortOrder;
};

const getSortBy = (visibleTabs, tabValue) => {
  const tabIndex = visibleTabs.findIndex((tab) => tab.id === tabValue);
  return `{"key":"inboundShipmentByCarrierByStatusByDates", "search":"${visibleTabs[tabIndex].sortKey}"}`;
};

// The tab's status id is persisted rather than its index: the index shifts
// whenever the tab list changes shape — a tab added or removed, or the small
// -screen filter dropping the ones with showSmall false — and a stale index
// would silently restore a different tab than the one the user left on.
const getSessionTab = (visibleTabs, appUser) => {
  const sessionTabId = sessionStorage.getItem(`InboundTab_${appUser.id}`);
  const sessionTab = visibleTabs.findIndex((tab) => tab.id === sessionTabId);
  return sessionTab === -1 ? 0 : sessionTab; // Default to the first visible tab
};

export const InboundList = (props) => {
  const { appUser } = useUser();
  const classes = useStyles();
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const smDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [visibleTabs, setVisibleTabs] = useState(getVisibleTabs(smDown));
  const [tabIndex, setTabIndex] = useState(getSessionTab(visibleTabs, appUser));

  const [defaultFilter, setDefaultFilter] = useState({
    carrierId: appUser.carrierId,
    statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime:
      {
        beginsWith: {
          status: visibleTabs[tabIndex].id,
        },
      },
  });
  const [defaultSearchFilter, setDefaultSearchFilter] = useState({
    reloadYardId: { eq: appUser?.reloadYardId },
    carrierId: { eq: appUser.carrierId },
    status: { eq: visibleTabs[tabIndex].id },
  });
  const defaultSort = {
    field: getSortBy(visibleTabs, visibleTabs[tabIndex].id),
    order: getSortOrder(visibleTabs, tabIndex),
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = Number(
    localStorage.getItem(`${props.resource}_perPage`),
  );
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? sessionPerPage : 10,
  );

  const listContext = useSearchableList({
    ...props,
    defaultTitle: "Deliveries",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
    resource: "inboundShipments",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listContext?.filter]);

  useEffect(() => {
    setVisibleTabs(getVisibleTabs(smDown));
  }, [smDown]);

  const handleTabChange = (value) => {
    debugger;
    setTabIndex(value);
    setDefaultFilter({
      carrierId: appUser.carrierId,
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime:
        {
          beginsWith: {
            status: visibleTabs[value].id,
          },
        },
    });
    setDefaultSearchFilter({
      reloadYardId: { eq: appUser?.reloadYardId },
      carrierId: { eq: appUser.carrierId },
      status: { eq: visibleTabs[value].id },
    });
    listContext.setSort(
      getSortBy(visibleTabs, visibleTabs[value].id),
      getSortOrder(visibleTabs, value),
    );
    listContext.setPage(1);
  };

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="Deliveries" />} />
      <ListToolbar
        {...props}
        filters={getListFilters(visibleTabs, tabIndex)}
        actions={<ListActions xsDown={xsDown} />}
      />
      <Card className={classes.listRoot}>
        <ShipmentTabs
          {...props}
          {...listContext}
          appUser={appUser}
          visibleTabs={visibleTabs}
          tabIndex={tabIndex}
          setTabIndex={handleTabChange}
          xsDown={xsDown}
          isMedium={smDown}
        />
        <Pagination {...listContext} />
      </Card>
    </ListContextProvider>
  );
};

const ShipmentTabs = ({ tabIndex, setTabIndex, setPage, ...props }) => {
  const { visibleTabs, appUser } = props;

  const handleChange = (event, value) => {
    const adjustedValue = visibleTabs[value] ? value : 0; // Adjust tab index to the first visible tab if needed
    sessionStorage.setItem(
      `InboundTab_${appUser.id}`,
      visibleTabs[adjustedValue].id,
    );
    setTabIndex(adjustedValue);
  };

  return (
    <>
      <Tabs
        value={Number(tabIndex)}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {visibleTabs.map((tab, idx) => (
          <Tab key={tab.id} label={tab.name} id={`shipment-${idx}`} />
        ))}
      </Tabs>
      <Divider />
      {visibleTabs.map(
        (tab) =>
          tab.id === visibleTabs[tabIndex].id && (
            <ShipmentGrid {...props} key={tab.id} tabValue={tab.id} />
          ),
      )}
    </>
  );
};

const ShipmentGrid = ({ ids, page, visibleTabs, tabValue, ...props }) => {
  const { xsDown, isMedium } = props;
  const rowClick = getRowClickAction(tabValue);

  return xsDown ? (
    <SimpleList
      linkType={rowClick}
      primaryText={(record) => record.accountName}
      secondaryText={(record) => `Car/Trl No:: ${record.railCarNumber}`}
      tertiaryText={(record) =>
        record.assignedTo ? truncateText(record.assignedTo, 12) : null
      }
      leftIcon={(record) => <InboundStateIcon record={record} />}
      rightIcon={() => (
        <ChevronRightIcon
          fontSize="large"
          color="secondary"
          style={{ marginLeft: 40, marginTop: 10 }}
        />
      )}
    />
  ) : isMedium ? (
    <Datagrid rowClick={rowClick}>
      {tabValue === InboundStatus.PLACED ||
      tabValue === InboundStatus.RELEASED ? (
        <InboundStateIcon />
      ) : null}
      {tabValue === InboundStatus.PLACED ||
      tabValue === InboundStatus.RELEASED ? (
        <FunctionField
          source="hasException"
          label=" "
          render={exceptionRenderer}
        />
      ) : null}
      {tabValue === InboundStatus.IN_TRANSIT ? (
        <YardDateField
          source="scheduledDateTime"
          label="Scheduled Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === InboundStatus.ARRIVED ? (
        <YardDateField
          source="notifyDateTime"
          label="Notify Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === InboundStatus.PLACED ? (
        <YardDateField
          source="placedDateTime"
          label="Placed Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === InboundStatus.RELEASED ? (
        <YardDateField
          source="releaseDateTime"
          label="Release Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      <TextField source="railCarNumber" label="Car/Trl No" sortable={true} />
      <TextField source="poNumber" label="PO Number" sortable={true} />
    </Datagrid>
  ) : (
    <Datagrid rowClick={rowClick} hasBulkActions={false}>
      {tabValue === InboundStatus.PLACED ||
      tabValue === InboundStatus.RELEASED ? (
        <InboundStateIcon />
      ) : null}
      {tabValue === InboundStatus.PLACED ||
      tabValue === InboundStatus.RELEASED ? (
        <FunctionField
          source="hasException"
          label=" "
          render={exceptionRenderer}
        />
      ) : null}
      {tabValue === InboundStatus.IN_TRANSIT ? (
        <YardDateField
          source="scheduledDateTime"
          label="Scheduled Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === InboundStatus.ARRIVED ? (
        <YardDateField
          source="notifyDateTime"
          label="Notify Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === InboundStatus.PLACED ? (
        <YardDateField
          source="placedDateTime"
          label="Placed Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === InboundStatus.RELEASED ? (
        <YardDateField
          source="releaseDateTime"
          label="Release Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      <TextField source="railCarNumber" label="Car/Trl No" sortable={true} />
      <TextField source="poNumber" label="PO Number" sortable={true} />
      {rowClick === "edit" ? <EditButton /> : <ShowButton />}
    </Datagrid>
  );
};
